//utils
import axios from 'axios';
import actions from 'store/actions';
import type {Dispatch} from 'redux';
import {StatusType} from 'store/status/types';
import {INonMember, Signatures} from 'types/nonMember';
import ActionType from 'store/actionTypes';
import {PublicEventType} from 'enums/public_event_type';

interface IBookEventProps {
  newLeadData?: Partial<INonMember>;
  memberId?: string;
  eventId: string;
  eventTitle: string;
  date: string;
  signatures?: Signatures;
  action: 'book' | 'cancel' | 'cancel-with-buddy';
  leadAttendanceId?: string;
  eventType?: PublicEventType;
  hasPrice: boolean;
}

export const book = async (props: IBookEventProps, dispatch: Dispatch, onSuccess?: () => void) => {
  const response = await axios.post('/public-events/book', {...props});

  if (response.status === 200) {
    const message =
      props.action === 'book'
        ? getBookedMessage(props.hasPrice, props.eventTitle)
        : 'Your booking has been successfully cancelled.';
    dispatch(actions.status.status({message, type: StatusType.SUCCESS}));

    let {event} = response.data;

    const isSeminarNonMember = !props.memberId && event.event.type === PublicEventType.SEMINAR;
    if (isSeminarNonMember) {
      event = {...event, isBookedByMe: false};
    }

    if (event) {
      dispatch({type: ActionType.UPDATE_PUBLIC_EVENTS_SUCCESS, data: {list: [event]}});
    }

    if (onSuccess) {
      onSuccess();
    }
    return event;
  }

  return undefined;
};

function getBookedMessage(hasPrice: boolean, title: string): string {
  if (hasPrice) {
    return 'To confirm your booking, kindly complete the payment via the payment link sent to the specified email. Thank you.';
  }

  return 'You have successfully booked ' + title;
}
